export type AddDieaseType = {
  diseaseClinicId: number;
  diseaseCode: string;
  diseaseCreatedByDate: string;
  diseaseCreatedById: number;
  diseaseName: string;
  diseaseStatus: number;
};

export type AddDieaseFormType = Omit<
  AddDieaseType,
  "diseaseClinicId" | "diseaseCreatedByDate" | "diseaseCreatedById"
>;

export type AddMedicalHistoryType = {
  id: number | null;
  encounter: number;
  disease: number;
  duration: string;
  medication: string;
  status: number;
  createdById: number;
  createdByDate: string;
  clinicId: number;
  isModified: number;
  userType: number;
  revertFlag: boolean;
};



export type SecondSaveType = {
  id?: number | null;
  encounter: number;
  takingAnyMedicationLastSixMonths: boolean;
  areYouPregnant: boolean;
  areYouReceiveAnyTreatment: boolean;
  breastFeeding: boolean;
  accuteOrChronicDiseases: boolean;
  medDetails: string;
  treatDetails: string;
  chronicDetails: string;
  areYouTakingBirthControlPills: boolean;
  medicationForChronicDisease: string;
  anyMedicineShouldNotBeInPrescription: string;
  pastSurguryDetails: string;
  others: string;
  status: number;
  createdById: number;
  clinicId: number;
  isModified: number;
  userType: number;
  revertFlag: boolean;
};

export type SecondMedicalHistoryFormType = Omit<
  SecondSaveType,
  | "userType"
  | "revertFlag"
  | "isModified"
  | "clinicId"
  | "createdById"
  | "status"
>;

export const initialMedicalHistorySecondData = {
  id: null,
  encounter: null,
  takingAnyMedicationLastSixMonths: null,
  areYouPregnant: null,
  areYouReceiveAnyTreatment: null,
  breastFeeding: null,
  accuteOrChronicDiseases: null,
  medDetails: "",
  treatDetails: "",
  chronicDetails: "",
  areYouTakingBirthControlPills: null,
  medicationForChronicDisease: "",
  anyMedicineShouldNotBeInPrescription: "",
  pastSurguryDetails: "",
  others: "",
};

export type DiseaseType = {
  icdId: number | null;
  icdCode: string | null;
  icdName: string;
};

export type MedicalHistoryListType = {
  id: number;
  encounter: number;
  duration: string;
  medication: string;
  status: number;
  createdById: number;
  clinicId: number;
  isModified: number;
  userType: number;
  revertFlag: false;
  emrDisease: {
    diseaseId: number;
    diseaseClinicId: number;
    diseaseCode: string;
    diseaseCreatedByDate: null;
    diseaseCreatedById: number;
    diseaseName: string;
    diseaseStatus: number;
  };
};

export type AddMedicalHistoryFormType = Omit<
MedicalHistoryListType,
  | "clinicId"
  | "createdByDate"
  | "createdById"
  | "userType"
  | "revertFlag"
  | "isModified"
>;

export type MedicalFormType = {
  id: number | null;
  duration: string;
  medication: string;
  diseaseDetails: DiseaseType | null;
};

export const initialMedicalHistoryData: MedicalFormType = {
  id: 0,
  duration: "",
  medication: "",
  diseaseDetails: null,
};

export type MedicalHistoryLogType = {
  anyMedicineShouldNotBeInPrescription: string;
  areYouReceiveAnyTreatment: boolean;
  accuteOrChronicDiseases: boolean;
  userName: string;
  medicationForChronicDisease: string;
  usergname: string;
  breastFeeding: boolean;
  createdDate: string;
  isModified: number;
  areYouTakingBirthControlPills: boolean;
  empName: string;
  pastSurguryDetails: string;
  id: number;
  userType: number;
  takingAnyMedicationLastSixMonths: boolean;
  areYouPregnant: boolean;
  others: string;
};
